import { render, staticRenderFns } from "./suppliePlatformConfigModal.vue?vue&type=template&id=2f577ce2"
import script from "./suppliePlatformConfigModal.vue?vue&type=script&lang=js"
export * from "./suppliePlatformConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports